import {Component, Input, OnInit, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';

@Component({
    selector: 'app-controlled-textarea',
    templateUrl: './controlled-textarea.component.html',
    styleUrls: ['./controlled-textarea.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ControlledTextareaComponent),
        multi: true}
    ]
})
export class ControlledTextareaComponent implements ControlValueAccessor, OnInit {

    @Input()
    public label: string;
    @Input()
    public placeholder: string;
    @Input()
    public maskValue: string;
    @Input()
    public showValidation: boolean;
    @Input()
    public isError: boolean;
    @Input()
    public disabled: boolean;

    @Input()
    public   name: string;

    @Input()
    public cols: number;
    @Input()
    public rows: number;

    @Input()
    public isTextareaVisible = true;

    public value = '';
    public propagateChange: (_: any) => void = (_: any) => { };
    public onTouched: () => void = () => { };

    public ngOnInit(): void {
    }


    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }


    public writeValue(value: string): void {
        this.value = value;
        this.isTextareaVisible  = !! this.value;
    }


    public updateChanges(): void {
        this.propagateChange(this.value);
        this.onTouched();
    }

    public updateTextareaState() {
        // checkgox was clicked .... clear value and propagate changes to ngModel
        this.value = null;
        this.updateChanges();
    }



}
